/* Luova.fi cart page. Quantity changes and removals go through Dawn's CartItems
   (assets/cart.js); this subclass only tells it which section to re-render (the single
   Luova cart section, not Dawn's items + footer pair) and handles the remove links. */
(() => {
  if (customElements.get('luova-cart-items') || typeof CartItems === 'undefined') return;

  class LuovaCartItems extends CartItems {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-luova-remove]');
        if (!remove) return;
        event.preventDefault();
        this.updateQuantity(remove.dataset.index, 0, event);
      });
    }

    getSectionsToRender() {
      return [
        { id: 'main-cart-items', section: this.dataset.id, selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      ];
    }

    /* Changes made elsewhere (the drawer, a product form) re-render this section. */
    onCartUpdate() {
      return fetch(`${routes.cart_url}?section_id=${this.dataset.id}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const source = html.querySelector('.js-contents');
          const target = this.querySelector('.js-contents');
          if (source && target) target.innerHTML = source.innerHTML;
        })
        .catch((e) => console.error(e));
    }
  }

  customElements.define('luova-cart-items', LuovaCartItems);
})();
